import {
  ReservedBucketCategorySchema,
  StorageLocationTypeSchema,
} from "@redotech/redo-fulfillment-wms-common/schema/storage-location";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const createStorageLocations = {
  name: "createStorageLocations" as const,
  input: z.object({
    names: z.array(z.string().min(1)).min(1, "At least one name is required"),
    locationId: locationIdFormat.schema,
    type: StorageLocationTypeSchema,
    isSellable: z.boolean().optional(),
    reservedBucketCategory: ReservedBucketCategorySchema.optional(),
  }),
  output: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema),
    errors: z.array(z.object({ name: z.string(), error: z.string() })),
  }),
};

export type CreateStorageLocationsInput = z.infer<
  typeof createStorageLocations.input
>;

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  PersistentLocationTypes,
  ReservedBucketCategorySchema,
  StorageLocationType,
} from "@redotech/redo-fulfillment-wms-common/schema/storage-location";
